import React, {
    ChangeEvent,
    KeyboardEvent,
    Suspense,
    useEffect,
    useState,
    useMemo,
    useRef,
    useCallback,
} from "react";
import { useDispatch } from "react-redux";
import {
    BlockWrapper,
    ButtonsWrapper,
    ErrorBlock,
    FlexBlock,
    GroupNameInput,
    HeaderTitle,
    HedgeInstIdBlock,
    SettingsBlockHeader,
    SettingsBlockTitle,
    SettingsBlockWrapper,
    TickerNameInput,
    Workspace,
    Wrapper,
} from "pages/settings/settingsPageStyles";
import SavedSettingsBlock from "components/SettingsModules/SavedSettingsBlock/SavedSettingsBlock";
import CommonSettings from "components/SettingsModules/CommonSettingsBlock/CommonSettings";
import MDPSettingsBlock from "components/SettingsModules/MDPSettingsBlock/MDPSettingsBlock";
import { RedButton } from "components/Buttons/buttonsStyles";
import AreYouSureModal from "components/AreYouSureModal/AreYouSureModal";
import {
    dropDraft,
    setLoading,
    getMDP,
    getTickerWorkspaces,
    setActiveTabId,
    addColumnConfig,
    saveTickerSettingsNew,
    deleteTickerWorkspace,
    updateTickerWorkspace,
    resetConfigs,
    incrementResetConfigsCounter,
    setIsTypeError,
    getScheduleParams,
    setSelectedSCId,
    resetSelectedSTSId,
    getScheduleIdTickers,
    resetSelectedTicker,
    resetState as resetSettingsState,
    setAvailableTickers as resetTickerSettings,
    deleteTickerWorkspaceConfig,
    setSelectedGroup,
    getTickerSettings,
    setSelectedTicker,
    getConfigFilesList,
    initializeConfigData,
    getMDPSourceTypes,
    getApplyFiles,
} from "store/reducers/SettingsSlice";
import { useAppSelector } from "hooks/redux";
import {
    applyGroup,
    applyTicker,
    getGroups,
    getTickersByGroup,
    renameGroup,
    renameTicker,
    resetState as resetGroupsState,
    resetGroupTickers,
} from "store/reducers/GroupsSlice";
import { setLogsTickerName } from "store/reducers/LogsSlice";
import { useLocation } from "react-router-dom";
import TradeParamsHandler from "utils/trade-params-handler";
import Error from "utils/Notifications/Error";
import TabsIndicator from "./settings.components/TabsIndicator";
import CreateWorkspaceModal from "./settings.components/CreateWorkSpaceModal";
import AddConfigBlock from "./settings.components/AddConfigBlock";
import AddConfigTypeModal from "./settings.components/AddConfigTypeModal";
import Loader from "components/Loader/Loader";
import BasedModal from "components/BaseModalComponents/BasedModal";
import { TrashIcon, GreenArrow } from "assets/images";
import ModalFooter from "components/BaseModalComponents/Footer/ModalFooter";
import ModalHeader from "components/BaseModalComponents/Header/ModalHeader";
import {
    Button,
    ButtonsBlock,
    Container,
    Content,
    ModalBody,
    ParamName,
    Row,
    TypeSelect,
} from "../../components/FilterModal/filterModalStyles";
import { setAvailableTickers } from "store/reducers/quotes";
import ApplyConfigModal from "components/modals/ApplyConfigModal";

const useQuery = () => {
    const { search } = useLocation();
    return useMemo(() => new URLSearchParams(search), [search]);
};

const SettingsPage = () => {
    const {
        MDPSelectedItem,
        activeGroup,
        activeTicker,
        isChanged,
        isNewTickerAdding,
        saved_settings,
        isTypeError,
        error,
        workspaceTabs,
        activeTabId,
        saved_configs,
        loading,
        selectedSCId,
        availableSCIds,
        sheduleExists,
        configFilesDetails,
        configFilesList,
        editMode,
        applyFiles,
    } = useAppSelector((state) => state.settings);

    const [autofillWarnings, setAutofillWarnings] = useState<string[]>([]);

    const selectedRobotId = useAppSelector(
        (state) => state.robots.selectedRobotId,
    );
    const dispatch = useDispatch();
    const { activeGroupTickers, groups } = useAppSelector(
        (state) => state.groups,
    );
    const get_ticker_settings_error = error;

    const q = useQuery();
    const [isCreateWorkspaceModalOpen, setIsCreateWorkspaceModalOpen] =
        useState(false);
    const [deletedWorkspaceId, setDeletedWorkspaceId] = useState<number | null>(
        null,
    );
    const [isAreYouSureModalOpen, setIsAreYouSureModalOpen] = useState(false);
    const [isFiltersModalOpen, setIsFiltersModalOpen] = useState(false);
    const [selectedScheduleId, setSelectedScheduleId] = useState(null);
    const [initSelectedScheduleId, setInitSelectedScheduleId] = useState(null);
    const [warningFields, setWarningFields] = useState<string[]>([]);

    const [applicableGroup, setApplicableGroup] = useState("");
    const [applicableTicker, setApplicableTicker] = useState<{
        tickerName: string;
        schedule_id: string;
        index: number;
    } | null>(null);

    useEffect(() => {
        setSelectedScheduleId(selectedSCId);
        setInitSelectedScheduleId(selectedSCId);

        if (activeGroup.name !== "Группа" && selectedSCId !== null)
            dispatch(
                getScheduleIdTickers({
                    group_name: activeGroup.name,
                    scheduleId: selectedSCId,
                }),
            );
        else dispatch(setAvailableTickers(null));
    }, [selectedSCId]);

    const availableTickers = useAppSelector(
        (store) => store.settings.availableTickers,
    );
// const state=useAppSelector((state) => state);
// console.log("state", state);
    useEffect(() => {
        if (activeGroup.name === "Группа" || !activeTicker.name) return;
        dispatch(
            getScheduleParams({
                group: activeGroup.name,
                ticker: activeTicker.name,
            }),
        );

        if (
            selectedSCId &&
            availableTickers != null &&
            !availableTickers
                .map((t) => t.ticker_name)
                .includes(activeTicker.name)
        )
            dispatch(resetSelectedTicker());
    }, [
        selectedSCId,
        availableTickers,
        activeTicker.name,
        activeGroup.name,
        dispatch,
    ]);

    const _onRestoreHandler = () => {
        setSelectedScheduleId(null);
    };

    const [areYouSureModalOpen, setAreYouSureModalOpen] =
        useState<boolean>(false);
    const [isTypeModalOpen, setIsTypeModalOpen] = useState(false);

    useEffect(() => {
        dispatch(setIsTypeError(false));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeGroup]);

    useEffect(() => {
        if (workspaceTabs && workspaceTabs.length > 0) {
            const activeWorkspace = workspaceTabs.find((w) => w.is_active);
            if (activeWorkspace) {
                dispatch(setActiveTabId(activeWorkspace.id));
            }
        }
    }, [workspaceTabs]);
    const handleWorkspaceTabClick = (workspaceId: number) => {
        dispatch(setActiveTabId(workspaceId));
        dispatch(
            updateTickerWorkspace({
                id: workspaceId,
                body: { is_active: true },
            }),
        );
    };

    const handleAddWorkspaceClick = () => {
        setIsCreateWorkspaceModalOpen(true);
    };
    const handleAddConfigClick = () => {
        setIsTypeModalOpen(true);
    };

    const handleChooseType = (code: string, is_horizontal: boolean) => {
        setIsTypeModalOpen(false);

        (dispatch as any)(
            addColumnConfig({
                groupId: activeGroup.name,
                config_code: code,
                nameTicker: activeTicker.name,
                workspace_id: activeTabId,
                is_horizontal: is_horizontal,
            }),
        );
    };
    const handleDeleteWorkspace = (workspaceId: number) => {
        setAreYouSureModalOpen(true);
        setAreYouSureType("deleteWorkspace");
        setAreYouSureMessage(
            "Вы уверены, что хотите удалить эту рабочую область?",
        );

        setDeletedWorkspaceId(workspaceId);
    };
    const handleDeleteConfig = (configId: number) => {
        if (!activeTabId) {
            Error("Не выбрана рабочая область");
            return;
        }

        setAreYouSureModalOpen(true);
        setAreYouSureType("deleteConfig");
        setAreYouSureMessage("Вы уверены, что хотите удалить этот конфиг?");
        setDeletedConfigId(configId);
    };

    const tickersGroup = useAppSelector(
        (state) => state.groups.activeGroupTickers,
    );

    const [areYouSureType, setAreYouSureType] = useState("");
    const [areYouSureMessage, setAreYouSureMessage] = useState<
        undefined | string
    >(undefined);

    const [isParamsSavingError, setIsParamsSavingError] = useState(false);

    const [newGroupName, setNewGroupName] = useState("");
    const [newTickerName, setNewTickerName] = useState("");
    const [deletedConfigId, setDeletedConfigId] = useState<number | null>(null);

    const scSchedules = useAppSelector((state) => state.settings.scSchedules);

    const currentSchedule = (scSchedules || []).find(
        (schedule) => schedule.id === activeTicker?.schedule_id,
    );

    const [isApplyConfigModalOpen, setIsApplyConfigModalOpen] = useState(false);
    const [selectedConfigIds, setSelectedConfigIds] = useState<
        (number | string)[]
    >([]);
    const [applyConfigModalTitle, setApplyConfigModalTitle] =
        useState<string>("");
    const [pendingApplyType, setPendingApplyType] = useState<
        | "applySettings"
        | "applySettingsForAll"
        | "applyGroup"
        | "applyTicker"
        | null
    >(null);

    useEffect(() => {
        dispatch(setLogsTickerName(""));
    }, [tickersGroup]);

    const isChangingRobotRef = useRef(false);
    const prevRobotIdRef = useRef(selectedRobotId);

    useEffect(() => {
        if (!selectedRobotId) return;

        dispatch(getApplyFiles());
    }, [selectedRobotId, dispatch]);

    // 1. Реальная смена робота — полный сброс

    useEffect(() => {
        if (!selectedRobotId) return;

        const isRealRobotChange = prevRobotIdRef.current !== selectedRobotId;
        prevRobotIdRef.current = selectedRobotId;

        if (!isRealRobotChange) return;

        isChangingRobotRef.current = true;

        dispatch(resetSettingsState());
        dispatch(resetGroupsState());
        dispatch(resetSelectedTicker());
        dispatch(resetTickerSettings(null));
        dispatch(resetGroupTickers());
        dispatch(setAvailableTickers(null));
        dispatch(resetSelectedSTSId());
        dispatch(setSelectedSCId(null));
        dispatch(setSelectedGroup({ name: "default", id: 0 }));
    }, [selectedRobotId, dispatch]);

    // 2. Обработка ?ticker= из URL (переход из DotsMenu)
    const tickerFromUrl = q.get("ticker");
    const scheduleIdFromUrl = q.get("schedule_id");
    const indexFromUrl = q.get("index") ? parseInt(q.get("index")!) : undefined;

    useEffect(() => {
        if (applyFiles?.length) {
            setSelectedConfigIds(applyFiles.map((f) => f.id));
        }
    }, [applyFiles]);

    useEffect(() => {
        if (!tickerFromUrl || !selectedRobotId) return;

        console.log("Переход по URL с тикером:", tickerFromUrl);

        dispatch(setSelectedGroup({ name: "default", id: 0 }));

        dispatch(
            setSelectedTicker({
                name: tickerFromUrl,
                schedule_id: scheduleIdFromUrl || "",
                index: indexFromUrl ?? 0,
                isNew: false,
            }),
        );
    }, [
        tickerFromUrl,
        scheduleIdFromUrl,
        indexFromUrl,
        selectedRobotId,
        dispatch,
    ]);

    useEffect(() => {
        if (!selectedRobotId || !groups?.length) return;

        const currentName = activeGroup?.name;
        const isDefaultOrEmpty =
            !currentName ||
            currentName === "Группа" ||
            currentName === "default" ||
            currentName === "";

        if (isDefaultOrEmpty) {
            const groupToSelect =
                groups.find((g) => {
                    const name = Array.isArray(g.name) ? g.name[0] : g.name;
                    return name === "default";
                }) || groups[0];

            if (groupToSelect) {
                const name = Array.isArray(groupToSelect.name)
                    ? groupToSelect.name[0]
                    : groupToSelect.name;
                dispatch(setSelectedGroup({ name, id: groupToSelect.id || 0 }));
            }
        }
    }, [selectedRobotId, groups, activeGroup?.name, dispatch]);

    // 2. Загрузка тикеров (только когда группа действительно выбрана)
    useEffect(() => {
        if (!selectedRobotId) return;
        if (!groups?.length) return;

        let groupName = activeGroup?.name;
        if (Array.isArray(groupName)) groupName = groupName[0];

        if (!groupName || groupName === "Группа" || groupName === "") {
            return;
        }

        const groupExists = groups.some((g) => {
            const gName = Array.isArray(g.name) ? g.name[0] : g.name;
            return gName === groupName;
        });

        if (groupExists) {
            dispatch(getTickersByGroup(groupName));
            dispatch(resetTickerSettings(null));
        } else {
            dispatch(setSelectedGroup({ name: "default", id: 0 }));
            dispatch(getTickersByGroup("default"));
        }
    }, [selectedRobotId, activeGroup?.name, groups, dispatch]);

    const hasAutoSelectedRef = useRef(false);

    useEffect(() => {
        const tickerFromUrl = q.get("ticker");
        if (!tickerFromUrl) return;
        if (hasAutoSelectedRef.current) return;
        if (!activeGroupTickers?.length) return;

        const found = activeGroupTickers.find(
            (t) =>
                t.name.ticker_name?.toLowerCase() ===
                tickerFromUrl.toLowerCase(),
        );

        if (found) {
            dispatch(
                setSelectedTicker({
                    name: found.name.ticker_name,
                    schedule_id: found.name.schedule_id,
                    index: found.name.index,
                    isNew: false,
                }),
            );

            hasAutoSelectedRef.current = true;
        }
    }, [activeGroupTickers, q, dispatch]);

    // 5. Загрузка настроек тикера
    useEffect(() => {
        const tickerFromUrl = q.get("ticker");

        if (
            activeGroup?.name === "default" &&
            activeTicker?.name &&
            activeTicker.name !== "Название тикера" &&
            tickerFromUrl &&
            activeTicker.name.toLowerCase() === tickerFromUrl.toLowerCase() &&
            activeTicker.schedule_id
        ) {
            dispatch(setLoading(true));
            dispatch(getTickerSettings());
        }
    }, [
        activeGroup?.name,
        activeTicker?.name,
        activeTicker?.schedule_id,
        q,
        dispatch,
    ]);
    useEffect(() => {
        if (!selectedRobotId) return;
        dispatch(initializeConfigData());
        dispatch(getMDPSourceTypes());
    }, [selectedRobotId, dispatch]);
    useEffect(() => {
        if (!selectedRobotId) return;
        dispatch(getConfigFilesList());
    }, [dispatch, selectedRobotId]);
    useEffect(() => {
        setNewGroupName(activeGroup.name);
    }, [activeGroup.name]);

    useEffect(() => {
        setNewTickerName(activeTicker.name);
        // dispatch(getTickerSettings());
    }, [activeTicker.name]);

    useEffect(() => {
        dispatch(getMDP());
    }, [isNewTickerAdding]);
    useEffect(() => {
        if (!selectedRobotId) return;

        dispatch(getTickerWorkspaces());
    }, [selectedRobotId, dispatch]);
    const stateHasChanges = () => {
        const check = TradeParamsHandler.stateHasChanges({
            saved_settings,
            affiliation: {
                ticker_name: activeTicker.name,
                group_name: activeGroup?.name,
                exchange_name: MDPSelectedItem?.SPname,
            },
        });
        return isChanged || check;
    };

    const handleChangeGroupName = (e: ChangeEvent<HTMLInputElement>) => {
        // if (activeGroup.name === 'default') return
        if (stateHasChanges()) {
            Error("Редактирование недоступно при несохраненных настройках");
            return;
        }
        setNewGroupName(e.target.value);
    };

    const handleRenameGroup = (e: KeyboardEvent<HTMLInputElement>) => {
        if (activeGroup.name === "default") return;
        if (e.key !== "Enter") return;
        const timeout = setTimeout(() => {
            setAreYouSureModalOpen(true);
            setAreYouSureType("renameGroup");
            setAreYouSureMessage("Название группы будет изменено");
            clearTimeout(timeout);
        }, 50);
    };

    const handleChangeTickerName = (e: ChangeEvent<HTMLInputElement>) => {
        if (activeTicker.name === "default") return;
        if (
            typeof get_ticker_settings_error === "string" &&
            get_ticker_settings_error.length
        ) {
            Error("Редактирование заблокированного тикера недоступно");
            return;
        }
        if (stateHasChanges()) {
            Error("Редактирование недоступно при несохраненных настройках");
            return;
        }
        setNewTickerName(e.target.value);
    };

    const handleTabTitleBlur = () => {
        if (
            newGroupName !== activeGroup?.name &&
            activeGroup.name !== "default"
        ) {
            setAreYouSureModalOpen(true);
            setAreYouSureMessage("Название группы будет изменено");
            setAreYouSureType("renameGroup");
            return;
        }

        if (
            newTickerName !== activeTicker?.name &&
            activeTicker.name !== "default"
        ) {
            setAreYouSureModalOpen(true);
            setAreYouSureMessage("Название тикера будет изменено");
            setAreYouSureType("renameTicker");
            return;
        }
    };

    const handleRenameTicker = (e: KeyboardEvent<HTMLInputElement>) => {
        // if (activeGroup.name === 'default') return
        if (e.key !== "Enter") return;
        setAreYouSureModalOpen(true);
        setAreYouSureType("renameTicker");
        setAreYouSureMessage("Название тикера будет изменено");
    };

    const handleCloseAreYouSureModal = () => {
        setAreYouSureModalOpen(false);
        setAreYouSureType("");
    };

    const handleResetSettingsButtonClick = () => {
        setAreYouSureModalOpen(true);
        setAreYouSureMessage(
            "Вы действительно хотите отменить введенные изменения?",
        );
        setAreYouSureType("resetSettings");
    };

    const handleApplyForAllSettingsButtonClick = () => {
        const emptyFields = getEmptyAutofillFields();

        setWarningFields(emptyFields);
        setAreYouSureModalOpen(true);
        if (activeGroup.name === "default") {
            setAreYouSureMessage("Данный тикер будет применен к роботу");
        } else
            setAreYouSureMessage(
                'Данный тикер будет включен в группу "Текущая"',
            );

        setAreYouSureType("applySettings");
    };
    const isDefaultGroup =
        activeGroup.name === "default" ||
        (Array.isArray(activeGroup.name) && activeGroup.name[1] === true);
    const handleApplySettingsForAllButtonClick = () => {
        const emptyFields = getEmptyAutofillFields();

        setWarningFields(emptyFields);

        if (isDefaultGroup) {
            setAreYouSureMessage("Данный тикер будет применен к роботу");
            setAreYouSureType("applySettingsForAll");
            setAreYouSureModalOpen(true);
            return;
        }
        setApplyConfigModalTitle("Применить настройки тикера?");
        setPendingApplyType("applySettingsForAll");
        setSelectedConfigIds(applyFiles?.map((f) => f.id) || []);
        setIsApplyConfigModalOpen(true);
    };

    const handleApplySettingsButtonClick = () => {
        const emptyFields = getEmptyAutofillFields();

        setWarningFields(emptyFields);
        if (isDefaultGroup) {
            setAreYouSureMessage("Данный тикер будет применен к роботу");
            setAreYouSureType("applySettings");
            setAreYouSureModalOpen(true);
            return;
        }
        setApplyConfigModalTitle("Применить настройки тикера?");
        setPendingApplyType("applySettings");
        setSelectedConfigIds(applyFiles?.map((f) => f.id) || []);
        setIsApplyConfigModalOpen(true);
    };

    const getAutofillWarnings = useCallback((): string[] => {
        const warnings: string[] = [];
        const includeInApplyCodes = Object.keys(configFilesDetails).filter(
            (code) => configFilesDetails[code]?.include_in_apply === true,
        );

        Object.entries(configFilesDetails).forEach(
            ([config_code, fileDetails]) => {
                if (!fileDetails?.fields?.length) return;
                if (!includeInApplyCodes.includes(config_code)) return;
                fileDetails.fields.forEach((field) => {
                    if (!field.autofill || field.autofill.length === 0) return;

                    field.autofill.forEach((af) => {
                        const sourceFile = af.source_file.toUpperCase();
                        const sourceField = af.source_field;

                        warnings.push(
                            `В поле ${config_code} ${field.name} стоит автоподстановка из ${sourceFile} ${sourceField}`,
                        );
                    });
                });
            },
        );

        return [...new Set(warnings)];
    }, [configFilesDetails]);

    const handleSaveSettingsButtonClick = () => {
        const emptyFields = getEmptyAutofillFields();
        setWarningFields(emptyFields);

        if (!isDefaultGroup) {
            const warnings = getAutofillWarnings();
            setAutofillWarnings(warnings);
            // setPendingApplyType("applySettings");
            setSelectedConfigIds(applyFiles?.map((f) => f.id) || []);
            // setIsApplyConfigModalOpen(true);
            setAreYouSureMessage("Сохранить настройки тикера?");
            setAreYouSureType("saveSettings");
            // setAreYouSureModalOpen(true);
            setApplyConfigModalTitle("Сохранить настройки тикера?");
            setAreYouSureModalOpen(true);
            return;
        }

        setAreYouSureMessage("Сохранить настройки тикера?");
        setAreYouSureType("saveSettings");
        setAreYouSureModalOpen(true);
    };

    const updateSettings =
        (notify: boolean, forAll?: boolean, config_ids?: (number | string)[]) =>
        async () => {
            if (!forAll) forAll = false;

            const result = await dispatch(
                saveTickerSettingsNew({
                    notify,
                    for_all: forAll,
                    config_ids: config_ids ?? selectedConfigIds,
                }),
            );
            // @ts-ignore
            if (result.error) {
                console.error("Ошибка при сохранении настроек:", result);
                // @ts-ignore
                setIsParamsSavingError(false); // не убирать!!!
                setIsParamsSavingError(true);
            } else {
                dispatch(incrementResetConfigsCounter());
                setIsParamsSavingError(false);
            }
            setAreYouSureModalOpen(false);
            setIsApplyConfigModalOpen(false);
        };
    const handleConfirmApplyConfigs = () => {
        if (!pendingApplyType) return;

        if (pendingApplyType === "applyGroup") {
            dispatch(
                applyGroup({
                    groupName: applicableGroup,
                    config_ids: selectedConfigIds,
                }),
            );
            setIsApplyConfigModalOpen(false);
            setPendingApplyType(null);
            return;
        }

        if (pendingApplyType === "applyTicker") {
            dispatch(
                applyTicker({
                    tickerName: applicableTicker.tickerName,
                    schedule_id: applicableTicker.schedule_id,
                    index: applicableTicker.index,
                    config_ids: selectedConfigIds,
                }),
            );
            setIsApplyConfigModalOpen(false);
            setPendingApplyType(null);
            return;
        }

        const forAll = pendingApplyType === "applySettingsForAll";
        updateSettings(true, forAll, selectedConfigIds)();

        setIsApplyConfigModalOpen(false);
        setPendingApplyType(null);
    };
    const handleAreYouSureApplyFunc = (type: string) => {
        switch (type) {
            default:
                return;
            case "resetSettings":
                return () => {
                    dispatch(setLoading(true));
                    dispatch(dropDraft());
                    dispatch(resetConfigs());
                    handleCloseAreYouSureModal();
                    setAreYouSureType("");
                    const timeout = setTimeout(() => {
                        dispatch(setLoading(false));
                        clearTimeout(timeout);
                    }, 100);
                };
            case "applySettings":
                return updateSettings(true);
            case "applySettingsForAll":
                return updateSettings(true, true);
            case "saveSettings":
                return updateSettings(false);
            case "renameGroup":
                return () => {
                    if (newGroupName === activeGroup.name) {
                        Error("Имя осталось без изменений");
                        setAreYouSureModalOpen(false);
                        setAreYouSureType("");
                        return;
                    }
                    setAreYouSureModalOpen(false);
                    setAreYouSureType("");
                    dispatch(renameGroup(newGroupName));
                };
            case "renameTicker":
                return () => {
                    setAreYouSureModalOpen(false);
                    setNewTickerName(activeTicker.name);
                    dispatch(renameTicker(newTickerName));
                    setAreYouSureType("");
                    unfocusInput();
                };
            case "cancelRename":
                return () => {
                    setAreYouSureModalOpen(false);
                    setNewTickerName(activeTicker.name);
                    setNewGroupName(activeGroup.name);
                    setAreYouSureType("");
                };
            case "deleteWorkspace":
                return () => {
                    if (deletedWorkspaceId !== null) {
                        dispatch(deleteTickerWorkspace(deletedWorkspaceId));
                    }
                    handleCloseAreYouSureModal();
                    setAreYouSureModalOpen(false);
                };
            case "deleteConfig":
                return () => {
                    if (deletedConfigId !== null && activeTabId !== null) {
                        dispatch(
                            deleteTickerWorkspaceConfig({
                                workspaceId: activeTabId,
                                configId: deletedConfigId,
                            }),
                        );
                    }
                    handleCloseAreYouSureModal();
                    setDeletedConfigId(null);
                };
        }
    };
    function unfocusInput() {
        const input = document.createElement("input");
        input.style.position = "absolute";
        input.style.bottom = "-150%";
        document.body.appendChild(input);
        input.focus();
        const timeout = setTimeout(() => {
            document.body.removeChild(input);
            return clearTimeout(timeout);
        }, 200);
    }

    const isTickerSelected = !(activeTicker.name === "Название тикера");
    const isGroupSelected = !(activeGroup.name === "Группа");
    const input_id = "ticker-settings-input";

    const currentTickerData = activeGroupTickers.find(
        (t) =>
            t.name.ticker_name === activeTicker.name &&
            t.name.schedule_id === activeTicker.schedule_id &&
            t.name.index === activeTicker.index,
    );

    const hedgeInstId =
        currentTickerData?.name.hedgeinst_id ||
        activeTicker?.hedgeinst_id ||
        "";

    const getEmptyAutofillFields = (): string[] => {
        const result: string[] = [];

        saved_configs.forEach((config) => {
            if (config.config_code !== "MDP") return;

            const metadata = configFilesDetails[config.config_code];
            const fields = metadata?.fields;

            if (!fields?.length || !config.all_values?.length) return;

            const valuesRow = config.all_values[config.all_values.length - 1];

            fields.forEach((field: any, idx: number) => {
                if (!field?.autofill?.length) return;

                const value = valuesRow?.[idx];

                if (value === "" || value === null || value === undefined) {
                    result.push(field.name);
                }
            });
        });

        return result;
    };

    return (
        <Wrapper>
            <HeaderTitle>
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        flex: 1,
                        gap: "8px",
                    }}
                >
                    {" "}
                    {isGroupSelected && (
                        <TickerNameInput
                            id={`${input_id}-ticker`}
                            value={
                                isTickerSelected
                                    ? newTickerName
                                    : "Выберите тикер"
                            }
                            // value={activeTicker.name}
                            disabled={
                                !isTickerSelected ||
                                isChanged ||
                                isNewTickerAdding ||
                                typeof get_ticker_settings_error === "string"
                            }
                            onChange={handleChangeTickerName}
                            onKeyDown={handleRenameTicker}
                            onBlur={handleTabTitleBlur}
                        />
                    )}
                    {isGroupSelected && " - "}
                    {isGroupSelected && (
                        <GroupNameInput
                            id={`${input_id}-group`}
                            onChange={handleChangeGroupName}
                            onKeyDown={handleRenameGroup}
                            onBlur={handleTabTitleBlur}
                            value={
                                activeGroup.name === "default"
                                    ? "Текущая"
                                    : Array.isArray(newGroupName)
                                      ? newGroupName[0]
                                      : newGroupName
                            }
                            disabled={
                                activeGroup.name === "default" ||
                                isChanged ||
                                isNewTickerAdding ||
                                typeof get_ticker_settings_error === "string"
                            }
                        />
                    )}
                    {!isGroupSelected && !isGroupSelected && "Выберите группу"}
                </div>
                <FlexBlock>
                    {currentSchedule && (
                        <HedgeInstIdBlock>
                            <span
                                style={{ color: "gray", paddingRight: "2px" }}
                            >
                                Время CP:{" "}
                            </span>
                            {currentSchedule?.id}
                            {availableSCIds?.filter(
                                (id) => id !== currentSchedule?.id,
                            ).length > 0 && (
                                <>({sheduleExists.join(", ")})</>
                            )}{" "}
                            {currentSchedule?.start_time} -{" "}
                            {currentSchedule?.end_time}
                        </HedgeInstIdBlock>
                    )}
                    {hedgeInstId && activeGroup && activeTicker && (
                        <HedgeInstIdBlock>
                            <span style={{ color: "gray" }}>Hedge: </span>
                            {hedgeInstId}
                        </HedgeInstIdBlock>
                    )}
                </FlexBlock>
            </HeaderTitle>
            {isTickerSelected && (
                <TabsIndicator
                    workspaceTabs={workspaceTabs}
                    activeWorkspaceId={activeTabId}
                    onTabClick={handleWorkspaceTabClick}
                    onAddTabClick={handleAddWorkspaceClick}
                    onDeleteClick={handleDeleteWorkspace}
                />
            )}
            <Workspace>
                <SettingsBlockWrapper>
                    <SettingsBlockHeader>
                        <SettingsBlockTitle>
                            Сохраненные настройки
                        </SettingsBlockTitle>

                        <RedButton
                            green
                            onClick={() => {
                                setIsFiltersModalOpen(true);
                                dispatch(
                                    getScheduleParams({
                                        group: activeGroup.name,
                                        ticker: activeTicker.name,
                                    }),
                                );
                            }}
                            disabled={activeGroup.name == "Группа"}
                            small
                        >
                            Время CP
                        </RedButton>
                    </SettingsBlockHeader>
                    <BlockWrapper>
                        <SavedSettingsBlock
                            setIsApplyConfigModalOpen={
                                setIsApplyConfigModalOpen
                            }
                            setSelectedConfigIds={setSelectedConfigIds}
                            setPendingApplyType={setPendingApplyType}
                            applyFiles={applyFiles}
                            getAutofillWarnings={getAutofillWarnings}
                            autofillWarnings={autofillWarnings}
                            setAutofillWarnings={setAutofillWarnings}
                            isAreYouSureModalOpen={isAreYouSureModalOpen}
                            setIsAreYouSureModalOpen={setIsAreYouSureModalOpen}
                            setApplyConfigModalTitle={setApplyConfigModalTitle}
                            setApplicableGroup={setApplicableGroup}
                            setApplicableTicker={setApplicableTicker}
                            applicableGroup={applicableGroup}
                            applicableTicker={applicableTicker}
                            selectedConfigIds={selectedConfigIds}
                        />
                    </BlockWrapper>
                </SettingsBlockWrapper>

                <Workspace>
                    <>
                        {loading ? (
                            <Loader />
                        ) : (
                            <>
                                {error ? (
                                    <ErrorBlock>
                                        {typeof error === "string"
                                            ? error
                                            : typeof error === "object" &&
                                                error.block
                                              ? error.block
                                              : "Произошла ошибка"}
                                    </ErrorBlock>
                                ) : activeGroup &&
                                  activeTicker.name !== "Название тикера" ? (
                                    [...saved_configs].map((config) => {
                                        const configMetadata =
                                            configFilesDetails[
                                                config.config_code
                                            ];

                                        const isUniqUi =
                                            configMetadata?.is_uniq_ui ||
                                            config.config_code === "MDP";

                                        if (
                                            config.config_code === "CP" &&
                                            selectedSCId
                                        ) {
                                            const cpScheduleId =
                                                config.all_values?.[1]?.[0];
                                            if (
                                                cpScheduleId &&
                                                cpScheduleId !== selectedSCId
                                            ) {
                                                return null;
                                            }
                                        }
                                        if (isUniqUi) {
                                            return (
                                                <MDPSettingsBlock
                                                    key={`${activeTicker.name}-${config.id}`}
                                                    handleDeleteConfig={
                                                        handleDeleteConfig
                                                    }
                                                    configMetadata={
                                                        configMetadata
                                                    }
                                                    isSavingError={
                                                        isParamsSavingError
                                                    }
                                                    config={config}
                                                    groupName={activeGroup.name}
                                                />
                                            );
                                        }
                                        return (
                                            <Suspense
                                                fallback={<p>Loading...</p>}
                                                key={`${activeTicker.name}-${config.id}`}
                                            >
                                                <CommonSettings
                                                    handleDeleteConfig={
                                                        handleDeleteConfig
                                                    }
                                                    isSavingError={
                                                        isParamsSavingError
                                                    }
                                                    config={config}
                                                    configMetadata={
                                                        configMetadata
                                                    }
                                                    activeTickerName={
                                                        activeTicker.name
                                                    }
                                                    groupId={activeGroup.name}
                                                />
                                            </Suspense>
                                        );
                                    })
                                ) : (
                                    <></>
                                )}
                                {!error &&
                                    saved_configs.length < 3 &&
                                    activeTicker &&
                                    activeTicker.name !== "Название тикера" &&
                                    editMode && (
                                        <AddConfigBlock
                                            onClick={handleAddConfigClick}
                                        />
                                    )}
                            </>
                        )}
                    </>
                </Workspace>
            </Workspace>
            {
                <ButtonsWrapper>
                    {
                        <RedButton
                            onClick={handleResetSettingsButtonClick}
                            disabled={!stateHasChanges()}
                        >
                            Отменить
                        </RedButton>
                    }
                    <RedButton
                        yellow
                        onClick={handleApplySettingsForAllButtonClick}
                        disabled={!stateHasChanges()}
                    >
                        Применить для всех
                    </RedButton>
                    <RedButton
                        yellow
                        onClick={handleApplySettingsButtonClick}
                        disabled={!stateHasChanges()}
                    >
                        Применить
                    </RedButton>
                    {activeGroup.name !== "default" && (
                        <RedButton
                            green
                            onClick={handleSaveSettingsButtonClick}
                            disabled={!stateHasChanges() || isTypeError}
                        >
                            Сохранить
                        </RedButton>
                    )}
                </ButtonsWrapper>
            }
            <Suspense fallback={<p>Loading...</p>}>
                {areYouSureModalOpen && (
                    <AreYouSureModal
                        title={"Вы уверены?"}
                        description={areYouSureMessage}
                        isOpen={areYouSureModalOpen}
                        onRequestClose={() => setAreYouSureModalOpen(false)}
                        onApplyClick={handleAreYouSureApplyFunc(areYouSureType)}
                        listTitle={
                            !isDefaultGroup && autofillWarnings.length
                                ? `Будут перенесены следующие файлы:\n$`
                                : warningFields.length
                                  ? "Внимание!"
                                  : undefined
                        }
                        listItems={
                            !isDefaultGroup && autofillWarnings.length
                                ? autofillWarnings
                                : warningFields.length
                                  ? warningFields.map(
                                        (field) => `Данное поле ${field} пусто`,
                                    )
                                  : undefined
                        }
                    />
                )}
            </Suspense>
            <CreateWorkspaceModal
                isOpen={isCreateWorkspaceModalOpen}
                onRequestClose={() => setIsCreateWorkspaceModalOpen(false)}
            />
            <AddConfigTypeModal
                isOpen={isTypeModalOpen}
                onRequestClose={() => setIsTypeModalOpen(false)}
                onChoose={handleChooseType}
                configFilesList={configFilesList}
            />
            <ApplyConfigModal
                isOpen={isApplyConfigModalOpen}
                title={applyConfigModalTitle}
                onRequestClose={() => {
                    setIsApplyConfigModalOpen(false);
                    setPendingApplyType(null);
                }}
                applyFiles={applyFiles || []}
                selectedConfigIds={selectedConfigIds}
                onChangeSelected={setSelectedConfigIds}
                onConfirm={handleConfirmApplyConfigs}
            />
            <BasedModal
                isOpen={isFiltersModalOpen}
                onRequestClose={() => setIsFiltersModalOpen(false)}
                style={{
                    overlay: {
                        position: "fixed",
                        zIndex: 100,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                    },
                    content: {
                        position: "static",
                        display: "flex",
                        flexDirection: "row",
                        gap: "10px",
                        width: "360px",
                        padding: 0,
                        boxShadow: "0px 0px 5px rgba(49, 69, 49, 0.14)",
                        borderRadius: "10px",
                    },
                }}
            >
                <Container>
                    <ModalHeader>
                        <div>Фильтры тикеров</div>
                        <ButtonsBlock>
                            <Button onClick={_onRestoreHandler}>
                                <TrashIcon />
                            </Button>
                        </ButtonsBlock>
                    </ModalHeader>
                    <ModalBody
                        thumbSize={60}
                        renderThumbVertical={(props: any) => (
                            <div
                                {...props}
                                style={{
                                    ...props.style,
                                    backgroundColor: "#7CBE7B",
                                    width: "6px",
                                    borderRadius: "10px",
                                }}
                            />
                        )}
                    >
                        <Row>
                            <Content
                                style={{ justifyContent: "space-between" }}
                            >
                                <ParamName>Shedule.ID</ParamName>
                                <TypeSelect
                                    value={{
                                        label:
                                            selectedScheduleId !== null
                                                ? selectedScheduleId
                                                : "Все",
                                        value: selectedScheduleId,
                                    }}
                                    onChange={(value: any) =>
                                        setSelectedScheduleId(value)
                                    }
                                    suffixIcon={
                                        <GreenArrow className="ant-select-suffix" />
                                    }
                                    placeholder="Тип фильтрации"
                                    options={[
                                        { label: "Все", value: null },
                                        ...availableSCIds.map((id) => {
                                            return { label: id, value: id };
                                        }),
                                    ]}
                                />
                            </Content>
                        </Row>
                    </ModalBody>
                    <ModalFooter
                        //disabled_apply_button={false}
                        onApplyClick={() => {
                            dispatch(setSelectedSCId(selectedScheduleId));
                            setIsFiltersModalOpen(false);
                        }}
                        applyText="Применить"
                        onCancelClick={() => {
                            setSelectedScheduleId(initSelectedScheduleId);
                            setIsFiltersModalOpen(false);
                        }}
                        cancelText="Отменить"
                        buttonBoxStyle={{
                            justifyContent: "space-between",
                            gap: 0,
                        }}
                    ></ModalFooter>
                </Container>
            </BasedModal>
        </Wrapper>
    );
};

export default SettingsPage;
